import LazyLoad from "vanilla-lazyload";
import lazyLoad from "./components/lazyLoad";
import ScrollToTop from "./components/scrollToTop";
import MobileBurgerMenu from "./components/mobileBurgerMenu";
import loadGame from "./components/loadGame";

document.addEventListener( 'DOMContentLoaded', function () {

	lazyLoad();

	let myLazyLoad = new LazyLoad();

	ScrollToTop();

	MobileBurgerMenu();

	// iframe on click
	loadGame();
} );


// import custom scripts
import './custom-app'
